/**
 * The jobs slice's name, in a module of its own so that it imports nothing.
 *
 * index.js and thunks.js import each other, and thunks.js reads this while it is still
 * loading, to build `getJobs`'s action type. Declared in index.js it was a `const` read before
 * its initialisation whenever index.js loaded first, which crashed the Vite dev server before
 * the CMS rendered. See store/rootReducerName.js, the same fix for the root slice.
 */
export const reducerName = 'jobs';
